




























import { Component, Prop, Watch,Vue } from 'vue-property-decorator'
@Component({
    components: {
    }
})
export default class ScrllImage extends Vue {


    @Prop()
    public imgList:any
    @Prop()
    public indexs:any
    @Prop()
    public cnt:any


    loadData(){

    }
    public nowleft:any = 0
    public allleft:any = 0
    public isright :any = true
    public isallleft:any =0
    mounted(){
        console.log('imgList',this.imgList)
        // this.nowleft = document.getElementById(('imgs'+this.indexs)).scrollLeft
        // setTimeout(_=>{
        var timer = setInterval( ()=> {
            // 判断文档和所有子资源(图片、音视频等)已完成加载
            if (document.readyState === 'complete') {
                //this.allleft = document.getElementById(('imgs'+this.indexs)).scrollWidth
                this.allleft = this.imgList.length*85;
                this.isallleft = document.getElementById(('imgs'+this.indexs)).offsetWidth
                if (this.imgList.length < this.cnt)  {
                    this.isright = false
                }
                console.log('allleft',this.nowleft,this.allleft, this.isallleft)
                clearInterval(timer)
            }
        }, 1000)
        // this.$nextTick(()=>{
        //      if (document.readyState === 'complete') {
        //         //this.allleft = document.getElementById(('imgs'+this.indexs)).scrollWidth
        //         this.allleft = 680;
        //         this.isallleft = document.getElementById(('imgs'+this.indexs)).offsetWidth
        //         if (this.imgList.length < this.cnt)  {
        //             this.isright = false
        //         }
        //         console.log('allleft',this.nowleft,this.allleft, this.isallleft)
        //         //clearInterval(timer)
        //     }
        // })


        // },2000)
    }
    public isgo:any = true
    public goleft() {
        // let res = document.getElementById(('imgs'+this.indexs)).scrollLeft - 85
        // console.log('goleft',document.getElementById(('imgs'+this.indexs)).scrollLeft,res )
        // document.getElementById(('imgs'+this.indexs)).scrollLeft = res;
        // this.nowleft = document.getElementById(('imgs'+this.indexs)).scrollLeft
        if (this.isgo) {
            this.isgo = false
            let xx = 0
            this.timeleft =setInterval(_=> {
                if (xx == 85) {
                    this.isgo = true
                    clearInterval(this.timeleft)
                } else {
                    document.getElementById(('imgs'+this.indexs)).scrollLeft = document.getElementById(('imgs'+this.indexs)).scrollLeft - 5;
                    this.nowleft = document.getElementById(('imgs'+this.indexs)).scrollLeft
                    // if ((this.nowleft + 85) >= this.allleft ) {
                    //     this.isright = false
                    // }
                }
                xx = xx + 5
            },30)
        }
    }
    public timeleft:any
    public timeend:any
    public goright() {
        // let res = document.getElementById(('imgs'+this.indexs)).scrollLeft + 85
        if (this.isgo) {
            this.isgo = false
            let xd = 0
            this.timeend = setInterval(_ => {
                if (xd == 85) {
                    this.isgo = true
                    clearInterval(this.timeend)
                } else {
                    document.getElementById(('imgs' + this.indexs)).scrollLeft = document.getElementById(('imgs' + this.indexs)).scrollLeft + 5;
                    this.nowleft = document.getElementById(('imgs' + this.indexs)).scrollLeft
                    if ((this.nowleft + 85) >= this.allleft) {
                        this.isright = false
                    }
                }
                xd = xd + 5
            }, 30)
        }
        // document.getElementById(('imgs'+this.indexs)).scrollLeft = res;

    }

    handleCurrentChange(val) {

    }
    destoryed(){
        console.log('destoryed-->',this.timeleft,this.timeend);
        if(this.timeleft){
            clearInterval(this.timeleft);
            this.timeleft = null;
        }
        if(this.timeend){
            clearInterval(this.timeend);
            this.timeend = null;
        }
    }

}
